import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import CSSTransition from 'react-transition-group/CSSTransition';

var AlertMessage = function AlertMessage(_ref) {
  var _ref$clearMessages = _ref.clearMessages,
      clearMessages = _ref$clearMessages === void 0 ? function () {} : _ref$clearMessages,
      manualDismiss = _ref.manualDismiss,
      message = _ref.message,
      messageType = _ref.messageType,
      _ref$onAlertDismiss = _ref.onAlertDismiss,
      onAlertDismiss = _ref$onAlertDismiss === void 0 ? function () {} : _ref$onAlertDismiss,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? true : _ref$timeout,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      alertVisible = _useState2[0],
      setAlertVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasAlert = _useState4[0],
      setHasAlert = _useState4[1];

  var timeoutRef = useRef();
  var dismissAlert = useCallback(function () {
    timeoutRef.current = undefined;
    setAlertVisible(false);
    setHasAlert(false);
    clearMessages();
  }, [clearMessages]);
  useEffect(function () {
    if (!manualDismiss && message) {
      timeoutRef.current = setTimeout(dismissAlert, 4000);
      setAlertVisible(true);
      return function () {
        return clearTimeout(timeoutRef.current);
      };
    } // If dismissAlert is added in the dependencies,
    // the alert keeps popping up as this effect is ran over and over
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [manualDismiss, message]);
  useEffect(function () {
    if (message && !manualDismiss && !timeout) {
      var _document$getElements;

      timeoutRef.current = setTimeout(dismissAlert, 4000);
      setAlertVisible(true);
      setHasAlert(((_document$getElements = document.getElementsByClassName('alert')) === null || _document$getElements === void 0 ? void 0 : _document$getElements.length) > 0);
    }
  }, [message, manualDismiss, timeout, dismissAlert]);

  var manualDismissFunc = function manualDismissFunc() {
    clearMessages();
    onAlertDismiss();
  };

  if (!message || hasAlert) return null;

  if (manualDismiss) {
    return /*#__PURE__*/React.createElement(Alert, {
      variant: messageType,
      onClose: manualDismissFunc,
      dismissible: true
    }, /*#__PURE__*/React.createElement("strong", null, message));
  }

  if (!visible || !alertVisible) return null;
  var onDismissFunc = timeout ? undefined : onAlertDismiss || dismissAlert;
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: "alert-transition",
    timeout: 1000
  }, /*#__PURE__*/React.createElement(Alert, {
    variant: messageType,
    onClose: onDismissFunc,
    transition: false
  }, /*#__PURE__*/React.createElement("strong", null, message)));
};

AlertMessage.displayName = "AlertMessage";
AlertMessage.displayName = 'AlertMessage';
export { AlertMessage };